/**
 * Whether this page draws the world in 3D (render3d, docs/archive/3D.md): `?render=3d` (or `?render=2d`
 * to force the 2.5D renderer) for one page, else the `render3d` setting. Kept apart from the 3D
 * renderer itself, which is loaded as its own chunk only when this says so (main.ts).
 */
import { settings } from '../settings';

export function render3dWanted(): boolean {
  const q = typeof location === 'undefined' ? null : new URLSearchParams(location.search).get('render');
  if (q === '3d') return true;
  if (q === '2d' || q === '2.5d') return false;
  return !!settings.render3d;
}
